import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type BadgeInput = {
  displayName: Scalars['String'];
  displayNameEn: Scalars['String'];
  displayNameKana?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyNameEn: Scalars['String'];
  companyNameKana?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  departmentEn?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  positionEn?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Scalars['String']>;
  prefectureEn: Scalars['String'];
  municipality?: Maybe<Scalars['String']>;
  municipalityEn: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  addressEn?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  tel?: Maybe<Scalars['String']>;
};

export type BadgeModel = {
   __typename?: 'BadgeModel';
  id: Scalars['ID'];
  barcodeId: Scalars['String'];
  displayName: Scalars['String'];
  displayNameEn: Scalars['String'];
  displayNameKana?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyNameEn: Scalars['String'];
  companyNameKana?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  departmentEn?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  positionEn?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Scalars['String']>;
  prefectureEn: Scalars['String'];
  municipality?: Maybe<Scalars['String']>;
  municipalityEn: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  addressEn?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  tel?: Maybe<Scalars['String']>;
  badgeNotifiedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ExhibitorInput = {
  accountId: Scalars['String'];
  password: Scalars['String'];
  exhibition: Scalars['String'];
  composition?: Maybe<Scalars['String']>;
  receptionId?: Maybe<Scalars['String']>;
  boothsCount?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  familyNameEn?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  givenNameEn?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyNameEn?: Maybe<Scalars['String']>;
  companyNameKana?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  departmentEn?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  positionEn?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Scalars['String']>;
  prefectureEn?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  municipalityEn?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  addressEn?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
};

export type ExhibitorModel = {
   __typename?: 'ExhibitorModel';
  id: Scalars['ID'];
  accountId: Scalars['String'];
  password: Scalars['String'];
  exhibition: Scalars['String'];
  composition?: Maybe<Scalars['String']>;
  receptionId?: Maybe<Scalars['String']>;
  boothsCount?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  familyNameEn?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  givenNameEn?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyNameEn?: Maybe<Scalars['String']>;
  companyNameKana?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  departmentEn?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  positionEn?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Scalars['String']>;
  prefectureEn?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  municipalityEn?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  addressEn?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  badges: Array<BadgeModel>;
  accountNotifiedAt?: Maybe<Scalars['String']>;
  remindNotifiedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ExhibitorsModel = {
   __typename?: 'ExhibitorsModel';
  records: Array<ExhibitorModel>;
  totalCount: Scalars['Int'];
  LastEvaluatedKeyId: Scalars['String'];
};

export type MailInput = {
  to: Scalars['String'];
  subject: Scalars['String'];
  message: Scalars['String'];
};

export type Mutation = {
   __typename?: 'Mutation';
  /** 出展者を作成する */
  createExhibitor: ExhibitorModel;
  /** idの出展者を更新 */
  updateExhibitor: ExhibitorModel;
  /** idの出展者を削除 */
  deleteExhibitor: Scalars['String'];
  /** アカウント情報通知送信 */
  sendAccountNotificationMail: Scalars['Boolean'];
  /** リマインド通知送信 */
  sendRemindNotificationMail: Scalars['Boolean'];
  /** バッジを作成する */
  createBadge: BadgeModel;
  /** idのバッジを更新 */
  updateBadge: BadgeModel;
  /** idのバッジを削除 */
  deleteBadge: Scalars['String'];
  /** バッジ通知送信 */
  sendBadgeNotificationMail: Scalars['Boolean'];
};


export type MutationCreateExhibitorArgs = {
  input: ExhibitorInput;
};


export type MutationUpdateExhibitorArgs = {
  input: ExhibitorInput;
  id: Scalars['ID'];
};


export type MutationDeleteExhibitorArgs = {
  id: Scalars['ID'];
};


export type MutationSendAccountNotificationMailArgs = {
  input: MailInput;
  id: Scalars['ID'];
};


export type MutationSendRemindNotificationMailArgs = {
  input: MailInput;
  id: Scalars['ID'];
};


export type MutationCreateBadgeArgs = {
  input: BadgeInput;
  exhibitorId: Scalars['ID'];
};


export type MutationUpdateBadgeArgs = {
  input: BadgeInput;
  id: Scalars['ID'];
  exhibitorId: Scalars['ID'];
};


export type MutationDeleteBadgeArgs = {
  id: Scalars['ID'];
  exhibitorId: Scalars['ID'];
};


export type MutationSendBadgeNotificationMailArgs = {
  input: MailInput;
  id: Scalars['ID'];
  exhibitorId: Scalars['ID'];
};

export type Query = {
   __typename?: 'Query';
  /** idの出展者を取得 */
  getExhibitorById: ExhibitorModel;
  /** tokenの出展者を取得 */
  getExhibitorByToken: ExhibitorModel;
  /** 出展者一覧 */
  getExhibitors: ExhibitorsModel;
};


export type QueryGetExhibitorByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetExhibitorByTokenArgs = {
  token: Scalars['String'];
};


export type QueryGetExhibitorsArgs = {
  ExclusiveStartKeyId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};

export type BadgeDetailFragment = (
  { __typename?: 'BadgeModel' }
  & Pick<BadgeModel, 'id' | 'barcodeId' | 'displayName' | 'displayNameEn' | 'displayNameKana' | 'companyName' | 'companyNameEn' | 'companyNameKana' | 'department' | 'departmentEn' | 'position' | 'positionEn' | 'postalCode' | 'prefecture' | 'prefectureEn' | 'municipality' | 'municipalityEn' | 'address' | 'addressEn' | 'email' | 'tel' | 'badgeNotifiedAt' | 'createdAt' | 'updatedAt'>
);

export type ExhibitorDetailFragment = (
  { __typename?: 'ExhibitorModel' }
  & Pick<ExhibitorModel, 'id' | 'accountId' | 'exhibition' | 'composition' | 'password' | 'receptionId' | 'boothsCount' | 'country' | 'familyName' | 'familyNameEn' | 'givenName' | 'givenNameEn' | 'companyName' | 'companyNameEn' | 'companyNameKana' | 'department' | 'departmentEn' | 'position' | 'positionEn' | 'postalCode' | 'prefecture' | 'prefectureEn' | 'municipality' | 'municipalityEn' | 'address' | 'addressEn' | 'email' | 'tel' | 'accountNotifiedAt' | 'remindNotifiedAt' | 'createdAt' | 'updatedAt'>
  & { badges: Array<(
    { __typename?: 'BadgeModel' }
    & BadgeDetailFragment
  )> }
);

export type CreateBadgeMutationVariables = {
  input: BadgeInput;
  exhibitorId: Scalars['ID'];
};


export type CreateBadgeMutation = (
  { __typename?: 'Mutation' }
  & { createBadge: (
    { __typename?: 'BadgeModel' }
    & BadgeDetailFragment
  ) }
);

export type CreateExhibitorMutationVariables = {
  input: ExhibitorInput;
};


export type CreateExhibitorMutation = (
  { __typename?: 'Mutation' }
  & { createExhibitor: (
    { __typename?: 'ExhibitorModel' }
    & ExhibitorDetailFragment
  ) }
);

export type DeleteBadgeMutationVariables = {
  id: Scalars['ID'];
  exhibitorId: Scalars['ID'];
};


export type DeleteBadgeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteBadge'>
);

export type DeleteExhibitorMutationVariables = {
  id: Scalars['ID'];
};


export type DeleteExhibitorMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteExhibitor'>
);

export type SendAccountNotificationMailMutationVariables = {
  id: Scalars['ID'];
  input: MailInput;
};


export type SendAccountNotificationMailMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendAccountNotificationMail'>
);

export type SendBadgeNotificationMailMutationVariables = {
  exhibitorId: Scalars['ID'];
  id: Scalars['ID'];
  input: MailInput;
};


export type SendBadgeNotificationMailMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendBadgeNotificationMail'>
);

export type SendRemindNotificationMailMutationVariables = {
  id: Scalars['ID'];
  input: MailInput;
};


export type SendRemindNotificationMailMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendRemindNotificationMail'>
);

export type UpdateBadgeMutationVariables = {
  exhibitorId: Scalars['ID'];
  id: Scalars['ID'];
  input: BadgeInput;
};


export type UpdateBadgeMutation = (
  { __typename?: 'Mutation' }
  & { updateBadge: (
    { __typename?: 'BadgeModel' }
    & BadgeDetailFragment
  ) }
);

export type UpdateExhibitorMutationVariables = {
  id: Scalars['ID'];
  input: ExhibitorInput;
};


export type UpdateExhibitorMutation = (
  { __typename?: 'Mutation' }
  & { updateExhibitor: (
    { __typename?: 'ExhibitorModel' }
    & ExhibitorDetailFragment
  ) }
);

export type GetExhibitorByIdQueryVariables = {
  id: Scalars['ID'];
};


export type GetExhibitorByIdQuery = (
  { __typename?: 'Query' }
  & { getExhibitorById: (
    { __typename?: 'ExhibitorModel' }
    & ExhibitorDetailFragment
  ) }
);

export type GetExhibitorByTokenQueryVariables = {
  token: Scalars['String'];
};


export type GetExhibitorByTokenQuery = (
  { __typename?: 'Query' }
  & { getExhibitorByToken: (
    { __typename?: 'ExhibitorModel' }
    & ExhibitorDetailFragment
  ) }
);

export type GetExhibitorsQueryVariables = {
  limit?: Maybe<Scalars['Int']>;
  ExclusiveStartKeyId?: Maybe<Scalars['String']>;
};


export type GetExhibitorsQuery = (
  { __typename?: 'Query' }
  & { getExhibitors: (
    { __typename?: 'ExhibitorsModel' }
    & Pick<ExhibitorsModel, 'totalCount' | 'LastEvaluatedKeyId'>
    & { records: Array<(
      { __typename?: 'ExhibitorModel' }
      & ExhibitorDetailFragment
    )> }
  ) }
);

export const BadgeDetailFragmentDoc = gql`
    fragment BadgeDetail on BadgeModel {
  id
  barcodeId
  displayName
  displayNameEn
  displayNameKana
  companyName
  companyNameEn
  companyNameKana
  department
  departmentEn
  position
  positionEn
  postalCode
  prefecture
  prefectureEn
  municipality
  municipalityEn
  address
  addressEn
  email
  tel
  badgeNotifiedAt
  createdAt
  updatedAt
}
    `;
export const ExhibitorDetailFragmentDoc = gql`
    fragment ExhibitorDetail on ExhibitorModel {
  id
  accountId
  exhibition
  composition
  password
  receptionId
  boothsCount
  country
  familyName
  familyNameEn
  givenName
  givenNameEn
  companyName
  companyNameEn
  companyNameKana
  department
  departmentEn
  position
  positionEn
  postalCode
  prefecture
  prefectureEn
  municipality
  municipalityEn
  address
  addressEn
  email
  tel
  badges {
    ...BadgeDetail
  }
  accountNotifiedAt
  remindNotifiedAt
  createdAt
  updatedAt
}
    ${BadgeDetailFragmentDoc}`;
export const CreateBadgeDocument = gql`
    mutation createBadge($input: BadgeInput!, $exhibitorId: ID!) {
  createBadge(input: $input, exhibitorId: $exhibitorId) {
    ...BadgeDetail
  }
}
    ${BadgeDetailFragmentDoc}`;
export type CreateBadgeMutationFn = ApolloReactCommon.MutationFunction<CreateBadgeMutation, CreateBadgeMutationVariables>;

/**
 * __useCreateBadgeMutation__
 *
 * To run a mutation, you first call `useCreateBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBadgeMutation, { data, loading, error }] = useCreateBadgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      exhibitorId: // value for 'exhibitorId'
 *   },
 * });
 */
export function useCreateBadgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBadgeMutation, CreateBadgeMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBadgeMutation, CreateBadgeMutationVariables>(CreateBadgeDocument, baseOptions);
      }
export type CreateBadgeMutationHookResult = ReturnType<typeof useCreateBadgeMutation>;
export type CreateBadgeMutationResult = ApolloReactCommon.MutationResult<CreateBadgeMutation>;
export type CreateBadgeMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBadgeMutation, CreateBadgeMutationVariables>;
export const CreateExhibitorDocument = gql`
    mutation createExhibitor($input: ExhibitorInput!) {
  createExhibitor(input: $input) {
    ...ExhibitorDetail
  }
}
    ${ExhibitorDetailFragmentDoc}`;
export type CreateExhibitorMutationFn = ApolloReactCommon.MutationFunction<CreateExhibitorMutation, CreateExhibitorMutationVariables>;

/**
 * __useCreateExhibitorMutation__
 *
 * To run a mutation, you first call `useCreateExhibitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExhibitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExhibitorMutation, { data, loading, error }] = useCreateExhibitorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExhibitorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateExhibitorMutation, CreateExhibitorMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateExhibitorMutation, CreateExhibitorMutationVariables>(CreateExhibitorDocument, baseOptions);
      }
export type CreateExhibitorMutationHookResult = ReturnType<typeof useCreateExhibitorMutation>;
export type CreateExhibitorMutationResult = ApolloReactCommon.MutationResult<CreateExhibitorMutation>;
export type CreateExhibitorMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateExhibitorMutation, CreateExhibitorMutationVariables>;
export const DeleteBadgeDocument = gql`
    mutation deleteBadge($id: ID!, $exhibitorId: ID!) {
  deleteBadge(id: $id, exhibitorId: $exhibitorId)
}
    `;
export type DeleteBadgeMutationFn = ApolloReactCommon.MutationFunction<DeleteBadgeMutation, DeleteBadgeMutationVariables>;

/**
 * __useDeleteBadgeMutation__
 *
 * To run a mutation, you first call `useDeleteBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBadgeMutation, { data, loading, error }] = useDeleteBadgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      exhibitorId: // value for 'exhibitorId'
 *   },
 * });
 */
export function useDeleteBadgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBadgeMutation, DeleteBadgeMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteBadgeMutation, DeleteBadgeMutationVariables>(DeleteBadgeDocument, baseOptions);
      }
export type DeleteBadgeMutationHookResult = ReturnType<typeof useDeleteBadgeMutation>;
export type DeleteBadgeMutationResult = ApolloReactCommon.MutationResult<DeleteBadgeMutation>;
export type DeleteBadgeMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteBadgeMutation, DeleteBadgeMutationVariables>;
export const DeleteExhibitorDocument = gql`
    mutation deleteExhibitor($id: ID!) {
  deleteExhibitor(id: $id)
}
    `;
export type DeleteExhibitorMutationFn = ApolloReactCommon.MutationFunction<DeleteExhibitorMutation, DeleteExhibitorMutationVariables>;

/**
 * __useDeleteExhibitorMutation__
 *
 * To run a mutation, you first call `useDeleteExhibitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExhibitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExhibitorMutation, { data, loading, error }] = useDeleteExhibitorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExhibitorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteExhibitorMutation, DeleteExhibitorMutationVariables>) {
        return ApolloReactHooks.useMutation<DeleteExhibitorMutation, DeleteExhibitorMutationVariables>(DeleteExhibitorDocument, baseOptions);
      }
export type DeleteExhibitorMutationHookResult = ReturnType<typeof useDeleteExhibitorMutation>;
export type DeleteExhibitorMutationResult = ApolloReactCommon.MutationResult<DeleteExhibitorMutation>;
export type DeleteExhibitorMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteExhibitorMutation, DeleteExhibitorMutationVariables>;
export const SendAccountNotificationMailDocument = gql`
    mutation sendAccountNotificationMail($id: ID!, $input: MailInput!) {
  sendAccountNotificationMail(id: $id, input: $input)
}
    `;
export type SendAccountNotificationMailMutationFn = ApolloReactCommon.MutationFunction<SendAccountNotificationMailMutation, SendAccountNotificationMailMutationVariables>;

/**
 * __useSendAccountNotificationMailMutation__
 *
 * To run a mutation, you first call `useSendAccountNotificationMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAccountNotificationMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAccountNotificationMailMutation, { data, loading, error }] = useSendAccountNotificationMailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAccountNotificationMailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendAccountNotificationMailMutation, SendAccountNotificationMailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendAccountNotificationMailMutation, SendAccountNotificationMailMutationVariables>(SendAccountNotificationMailDocument, baseOptions);
      }
export type SendAccountNotificationMailMutationHookResult = ReturnType<typeof useSendAccountNotificationMailMutation>;
export type SendAccountNotificationMailMutationResult = ApolloReactCommon.MutationResult<SendAccountNotificationMailMutation>;
export type SendAccountNotificationMailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendAccountNotificationMailMutation, SendAccountNotificationMailMutationVariables>;
export const SendBadgeNotificationMailDocument = gql`
    mutation sendBadgeNotificationMail($exhibitorId: ID!, $id: ID!, $input: MailInput!) {
  sendBadgeNotificationMail(exhibitorId: $exhibitorId, id: $id, input: $input)
}
    `;
export type SendBadgeNotificationMailMutationFn = ApolloReactCommon.MutationFunction<SendBadgeNotificationMailMutation, SendBadgeNotificationMailMutationVariables>;

/**
 * __useSendBadgeNotificationMailMutation__
 *
 * To run a mutation, you first call `useSendBadgeNotificationMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBadgeNotificationMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBadgeNotificationMailMutation, { data, loading, error }] = useSendBadgeNotificationMailMutation({
 *   variables: {
 *      exhibitorId: // value for 'exhibitorId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendBadgeNotificationMailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendBadgeNotificationMailMutation, SendBadgeNotificationMailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendBadgeNotificationMailMutation, SendBadgeNotificationMailMutationVariables>(SendBadgeNotificationMailDocument, baseOptions);
      }
export type SendBadgeNotificationMailMutationHookResult = ReturnType<typeof useSendBadgeNotificationMailMutation>;
export type SendBadgeNotificationMailMutationResult = ApolloReactCommon.MutationResult<SendBadgeNotificationMailMutation>;
export type SendBadgeNotificationMailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendBadgeNotificationMailMutation, SendBadgeNotificationMailMutationVariables>;
export const SendRemindNotificationMailDocument = gql`
    mutation sendRemindNotificationMail($id: ID!, $input: MailInput!) {
  sendRemindNotificationMail(id: $id, input: $input)
}
    `;
export type SendRemindNotificationMailMutationFn = ApolloReactCommon.MutationFunction<SendRemindNotificationMailMutation, SendRemindNotificationMailMutationVariables>;

/**
 * __useSendRemindNotificationMailMutation__
 *
 * To run a mutation, you first call `useSendRemindNotificationMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRemindNotificationMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRemindNotificationMailMutation, { data, loading, error }] = useSendRemindNotificationMailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendRemindNotificationMailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendRemindNotificationMailMutation, SendRemindNotificationMailMutationVariables>) {
        return ApolloReactHooks.useMutation<SendRemindNotificationMailMutation, SendRemindNotificationMailMutationVariables>(SendRemindNotificationMailDocument, baseOptions);
      }
export type SendRemindNotificationMailMutationHookResult = ReturnType<typeof useSendRemindNotificationMailMutation>;
export type SendRemindNotificationMailMutationResult = ApolloReactCommon.MutationResult<SendRemindNotificationMailMutation>;
export type SendRemindNotificationMailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendRemindNotificationMailMutation, SendRemindNotificationMailMutationVariables>;
export const UpdateBadgeDocument = gql`
    mutation updateBadge($exhibitorId: ID!, $id: ID!, $input: BadgeInput!) {
  updateBadge(exhibitorId: $exhibitorId, id: $id, input: $input) {
    ...BadgeDetail
  }
}
    ${BadgeDetailFragmentDoc}`;
export type UpdateBadgeMutationFn = ApolloReactCommon.MutationFunction<UpdateBadgeMutation, UpdateBadgeMutationVariables>;

/**
 * __useUpdateBadgeMutation__
 *
 * To run a mutation, you first call `useUpdateBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBadgeMutation, { data, loading, error }] = useUpdateBadgeMutation({
 *   variables: {
 *      exhibitorId: // value for 'exhibitorId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBadgeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBadgeMutation, UpdateBadgeMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateBadgeMutation, UpdateBadgeMutationVariables>(UpdateBadgeDocument, baseOptions);
      }
export type UpdateBadgeMutationHookResult = ReturnType<typeof useUpdateBadgeMutation>;
export type UpdateBadgeMutationResult = ApolloReactCommon.MutationResult<UpdateBadgeMutation>;
export type UpdateBadgeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateBadgeMutation, UpdateBadgeMutationVariables>;
export const UpdateExhibitorDocument = gql`
    mutation updateExhibitor($id: ID!, $input: ExhibitorInput!) {
  updateExhibitor(id: $id, input: $input) {
    ...ExhibitorDetail
  }
}
    ${ExhibitorDetailFragmentDoc}`;
export type UpdateExhibitorMutationFn = ApolloReactCommon.MutationFunction<UpdateExhibitorMutation, UpdateExhibitorMutationVariables>;

/**
 * __useUpdateExhibitorMutation__
 *
 * To run a mutation, you first call `useUpdateExhibitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExhibitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExhibitorMutation, { data, loading, error }] = useUpdateExhibitorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExhibitorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateExhibitorMutation, UpdateExhibitorMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateExhibitorMutation, UpdateExhibitorMutationVariables>(UpdateExhibitorDocument, baseOptions);
      }
export type UpdateExhibitorMutationHookResult = ReturnType<typeof useUpdateExhibitorMutation>;
export type UpdateExhibitorMutationResult = ApolloReactCommon.MutationResult<UpdateExhibitorMutation>;
export type UpdateExhibitorMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateExhibitorMutation, UpdateExhibitorMutationVariables>;
export const GetExhibitorByIdDocument = gql`
    query getExhibitorById($id: ID!) {
  getExhibitorById(id: $id) {
    ...ExhibitorDetail
  }
}
    ${ExhibitorDetailFragmentDoc}`;

/**
 * __useGetExhibitorByIdQuery__
 *
 * To run a query within a React component, call `useGetExhibitorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExhibitorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExhibitorByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExhibitorByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExhibitorByIdQuery, GetExhibitorByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<GetExhibitorByIdQuery, GetExhibitorByIdQueryVariables>(GetExhibitorByIdDocument, baseOptions);
      }
export function useGetExhibitorByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExhibitorByIdQuery, GetExhibitorByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetExhibitorByIdQuery, GetExhibitorByIdQueryVariables>(GetExhibitorByIdDocument, baseOptions);
        }
export type GetExhibitorByIdQueryHookResult = ReturnType<typeof useGetExhibitorByIdQuery>;
export type GetExhibitorByIdLazyQueryHookResult = ReturnType<typeof useGetExhibitorByIdLazyQuery>;
export type GetExhibitorByIdQueryResult = ApolloReactCommon.QueryResult<GetExhibitorByIdQuery, GetExhibitorByIdQueryVariables>;
export const GetExhibitorByTokenDocument = gql`
    query getExhibitorByToken($token: String!) {
  getExhibitorByToken(token: $token) {
    ...ExhibitorDetail
  }
}
    ${ExhibitorDetailFragmentDoc}`;

/**
 * __useGetExhibitorByTokenQuery__
 *
 * To run a query within a React component, call `useGetExhibitorByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExhibitorByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExhibitorByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetExhibitorByTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExhibitorByTokenQuery, GetExhibitorByTokenQueryVariables>) {
        return ApolloReactHooks.useQuery<GetExhibitorByTokenQuery, GetExhibitorByTokenQueryVariables>(GetExhibitorByTokenDocument, baseOptions);
      }
export function useGetExhibitorByTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExhibitorByTokenQuery, GetExhibitorByTokenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetExhibitorByTokenQuery, GetExhibitorByTokenQueryVariables>(GetExhibitorByTokenDocument, baseOptions);
        }
export type GetExhibitorByTokenQueryHookResult = ReturnType<typeof useGetExhibitorByTokenQuery>;
export type GetExhibitorByTokenLazyQueryHookResult = ReturnType<typeof useGetExhibitorByTokenLazyQuery>;
export type GetExhibitorByTokenQueryResult = ApolloReactCommon.QueryResult<GetExhibitorByTokenQuery, GetExhibitorByTokenQueryVariables>;
export const GetExhibitorsDocument = gql`
    query getExhibitors($limit: Int, $ExclusiveStartKeyId: String) {
  getExhibitors(limit: $limit, ExclusiveStartKeyId: $ExclusiveStartKeyId) {
    totalCount
    records {
      ...ExhibitorDetail
    }
    LastEvaluatedKeyId
  }
}
    ${ExhibitorDetailFragmentDoc}`;

/**
 * __useGetExhibitorsQuery__
 *
 * To run a query within a React component, call `useGetExhibitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExhibitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExhibitorsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      ExclusiveStartKeyId: // value for 'ExclusiveStartKeyId'
 *   },
 * });
 */
export function useGetExhibitorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetExhibitorsQuery, GetExhibitorsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetExhibitorsQuery, GetExhibitorsQueryVariables>(GetExhibitorsDocument, baseOptions);
      }
export function useGetExhibitorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetExhibitorsQuery, GetExhibitorsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetExhibitorsQuery, GetExhibitorsQueryVariables>(GetExhibitorsDocument, baseOptions);
        }
export type GetExhibitorsQueryHookResult = ReturnType<typeof useGetExhibitorsQuery>;
export type GetExhibitorsLazyQueryHookResult = ReturnType<typeof useGetExhibitorsLazyQuery>;
export type GetExhibitorsQueryResult = ApolloReactCommon.QueryResult<GetExhibitorsQuery, GetExhibitorsQueryVariables>;